






















import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";

@Component({})
export default class Accordion extends Vue {
  open = false;

  @Prop({
    default: false,
    required: false
  })
  active: boolean;

  @Prop({
    default: false,
    required: false
  })
  disabled: boolean;

  @Prop({
    default: false
  })
  empty: boolean;
  @Prop({
    default: false
  })
  alwaysOpen: true;

  constructor() {
    super();
    this.open = this.active;
  }

  toggle() {
    if (!this.disabled) {
      this.open = !this.open;
      this.$emit("update:active", this.open);
    }
  }

  @Watch("active")
  onActiveChange(value: boolean) {
    this.open = value;
  }
}
